<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card p-5">
          <div class="row">
            <div class="col-12">
              <h3>Tenants Summary</h3>
              <p>List of tenants only with their outstanding balance</p>
              <a
                :href="`/reports/tenants-outstanding-balances?cid=${company_id}`"
                class="btn btn-sm btn-primary"
                target="_new"
              >
                 <i class="lni lni-printer"></i> Print
              </a>

              <hr />
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <h3>Properties Summary</h3>
              <p>List of properties</p>
              <a
                :href="`/reports/properties?cid=${company_id}`"
                class="btn btn-sm btn-primary"
                target="_new"
              >
                 <i class="lni lni-printer"></i> Print
              </a>

              <hr />
            </div>
          </div>


           <div class="row mt-4">
            <div class="col-12">
              <h3>Inventory Summary</h3>
              <p>List of inventory items</p>
              <a
                :href="`/reports/inventory?cid=${company_id}`"
                class="btn btn-sm btn-primary"
                target="_new"
              >
                <i class="lni lni-printer"></i> Print
              </a>

              <hr />
            </div>
          </div>

          <div class="row mt-4">
            <!-- Date Selector -->
            <div class="col-12">
              <h5 class="m-0">Select date range for reporting below:</h5>
              <small class="text-muted">Maximum 1 year range</small>
              <div class="row">
                <div class="col-md-6">
                  <label for="from">From</label>
                  <b-form-datepicker
                    id="from"
                    v-model="from"
                    class="mb-2"
                  ></b-form-datepicker>
                </div>
                <div class="col-md-6">
                  <label for="to">To</label>
                  <b-form-datepicker
                    id="to"
                    v-model="to"
                    class="mb-2"
                  ></b-form-datepicker>
                </div>
              </div>
            </div>

            <!-- Financials -->
            <div class="col-lg-6">
              <div class="row mt-5">
                <div class="col-auto">
                  <button
                    @click="financialInRange"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
                <div class="col">
                  <h3 class="m-0">Financial Summary</h3>
                  <p>Financial report for selected period</p>
                </div>
              </div>
            </div>

            <!-- Invoices -->
            <div class="col-lg-6">
              <div class="row mt-5">
                <div class="col-auto">
                  <button
                    @click="invoicesInRange"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
                <div class="col">
                  <h3 class="m-0">Invoices</h3>
                  <p>Invoices for selected period</p>
                </div>
              </div>
            </div>

            <!-- Payments -->
            <div class="col-lg-6">
              <div class="row mt-5">
                <div class="col-auto">
                  <button
                    @click="paymentsInRange"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
                <div class="col">
                  <h3 class="m-0">Payments</h3>
                  <p>Payments for selected period</p>
                </div>
              </div>
            </div>

            <!-- Debits-->
            <div class="col-lg-6">
              <div class="row mt-5">
                <div class="col-auto">
                  <button @click="debitsInRange" class="btn btn-sm btn-primary">
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
                <div class="col">
                  <h3 class="m-0">Debits</h3>
                  <p>Debits for selected period</p>
                </div>
              </div>
            </div>

            <!-- Credits -->
            <div class="col-lg-6">
              <div class="row mt-5">
                <div class="col-auto">
                  <button
                    @click="creditsInRange"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
                <div class="col">
                  <h3 class="m-0">Credits</h3>
                  <p>Credits for selected period</p>
                </div>
              </div>
            </div>


              <!-- Expenses -->
            <div class="col-lg-6">
              <div class="row mt-5">
                <div class="col-auto">
                  <button
                    @click="expensesInRange"
                    class="btn btn-sm btn-primary"
                  >
                    <i class="lni lni-printer"></i> Print
                  </button>
                </div>
                <div class="col">
                  <h3 class="m-0">Expenses</h3>
                  <p>Expenses for selected period</p>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      from: this.moment().subtract(3, "months").format("YYYY-MM-DD"),
      to: this.moment().format("YYYY-MM-DD"),
      company_id: localStorage.getItem("current_company_id"),
      loading: false,
    };
  },

  mounted() {},

  methods: {
    checkRange() {
      //from is not greate
      if (this.moment(this.from).isAfter(this.moment(this.to))) {
        this.$root.$bvToast.toast("From can not be after to", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      //not more then a year
      if (this.moment(this.to).diff(this.moment(this.from), "days") > 366) {
        this.$root.$bvToast.toast("Range can not be greater than 1 year", {
          title: "Invalid Range",
          autoHideDelay: 3000,
          variant: "danger",
        });
        return false;
      }

      return true;
    },
    async financialInRange() {
      if (this.checkRange()) {
        window.open(
          `/reports/financial?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`
        );
      }
    },
     async invoicesInRange() {
      if (this.checkRange()) {
        window.open(
          `/reports/invoices?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`
        );
      }
    },
     async paymentsInRange() {
      if (this.checkRange()) {
        window.open(
          `/reports/payments?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`
        );
      }
    },
     async debitsInRange() {
      if (this.checkRange()) {
        window.open(
          `/reports/debits?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`
        );
      }
    },
     async creditsInRange() {
      if (this.checkRange()) {
        window.open(
          `/reports/credits?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`
        );
      }
    },
     async expensesInRange() {
      if (this.checkRange()) {
        window.open(
          `/reports/expenses?cid=${this.company_id}&report=range&from=${this.from}&to=${this.to}`
        );
      }
    },
  },
};
</script>

<style>
</style>